import currentLevel from '../app/wordList/unit/currentLevel';

export const reducer = {
  currentLevel,
};
